import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Kitchen Open',
    description: "Kitchen Open is pickleball's spring major: 560 players, 18 courts and four days in Palm Desert, California, April 8 to 11, 2027. Get passes or enter a team.",
    url: getOrigin(),
    ogImage: 'https://kitchen-open.cdn.modulify.website/images/share/kitchen-open-center-court.jpg'
}
